import { IconArrowLeft as ArrowLeft } from "@tabler/icons-react";
import { SectionHeader } from "../components/shared/SectionHeader";

export function DisclaimerPage({ t }) {
  return (
    <main>
      <section className="relative overflow-hidden pt-32 pb-24 md:pt-40 md:pb-32">
        <div
          className="orb"
          style={{
            width: 440,
            height: 440,
            background: "hsl(var(--brand) / 0.18)",
            top: 80,
            right: -140,
          }}
        />

        <div className="container-x relative">
          <a href="/" className="btn-pill btn-ghost mb-10 w-fit text-sm">
            <ArrowLeft className="h-4 w-4" />
            {t.disclaimer.back}
          </a>

          <SectionHeader eyebrow={t.disclaimer.eyebrow} title={t.disclaimer.title} />

          <section className="reveal mt-12 rounded-2xl border border-[hsl(var(--border))] bg-[hsl(var(--surface))] p-6 md:p-8">
            <div className="max-w-4xl space-y-6 text-base leading-relaxed">
              {t.disclaimer.intro.map((paragraph) => (
                <p key={paragraph}>{paragraph}</p>
              ))}

              <div>
                <h3 className="font-mono text-xs font-semibold uppercase tracking-[0.18em] text-muted-foreground">
                  {t.disclaimer.subheading}
                </h3>
                <ul className="mt-5 space-y-4">
                  {t.disclaimer.items.map((item) => (
                    <li key={item} className="flex gap-3">
                      <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-brand" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </section>
        </div>
      </section>
    </main>
  );
}
